/** Reason codes from PortalApi learning-center/authorize (Auth0 Post Login redirect query param). */
export const LEARNING_CENTER_ACCESS_DENIED_REASONS = {
	NOT_SALESFORCE_APPROVED: 'NOT_SALESFORCE_APPROVED',
	PORTAL_USER_MISSING: 'PORTAL_USER_MISSING',
	NO_BRANCH_PERMISSION: 'NO_BRANCH_PERMISSION',
	LOOKUP_FAILED: 'LOOKUP_FAILED',
	TALENTLMS_SYNC_FAILED: 'TALENTLMS_SYNC_FAILED',
	EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
	BLOCKED_USER: 'BLOCKED_USER',
	CONFIGURATION_ERROR: 'CONFIGURATION_ERROR',
	CONTACT_SUPPORT: 'CONTACT_SUPPORT',
	BAD_REQUEST: 'BAD_REQUEST',
	SERVER_UNREACHABLE: 'SERVER_UNREACHABLE',
	UNKNOWN: 'UNKNOWN',
};

const GENERIC_SUPPORT_MESSAGE =
	'We could not sign you in to the Learning Center. Please contact Metabolon support for assistance.';

const MESSAGES = {
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.NOT_SALESFORCE_APPROVED]:
		"Almost there, your account is being verified. You'll be notified within 1 business day.",
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.PORTAL_USER_MISSING]:
		'A Portal account is required before you can access the Learning Center. Please register on the Portal first.',
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.NO_BRANCH_PERMISSION]:
		"You don't have Learning Center access assigned. Contact your administrator.",
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.LOOKUP_FAILED]:
		"We couldn't verify your Learning Center access right now. Please try again later.",
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.TALENTLMS_SYNC_FAILED]:
		"We couldn't synchronize your Learning Center access right now. Please try again later.",
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.EMAIL_NOT_VERIFIED]:
		'Please check your email and click the verification link we sent you, then try signing in to the Learning Center again.',
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.BLOCKED_USER]: GENERIC_SUPPORT_MESSAGE,
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.CONFIGURATION_ERROR]: GENERIC_SUPPORT_MESSAGE,
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.CONTACT_SUPPORT]: GENERIC_SUPPORT_MESSAGE,
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.BAD_REQUEST]: GENERIC_SUPPORT_MESSAGE,
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.SERVER_UNREACHABLE]: GENERIC_SUPPORT_MESSAGE,
	[LEARNING_CENTER_ACCESS_DENIED_REASONS.UNKNOWN]: GENERIC_SUPPORT_MESSAGE,
};

export function normalizeLearningCenterAccessDeniedReason(rawReason) {
	const normalized = (rawReason || '').trim().toUpperCase();
	if (normalized && MESSAGES[normalized]) {
		return normalized;
	}
	return LEARNING_CENTER_ACCESS_DENIED_REASONS.CONTACT_SUPPORT;
}

export function getLearningCenterAccessDeniedMessage(rawReason) {
	return MESSAGES[normalizeLearningCenterAccessDeniedReason(rawReason)];
}
